export default __webpack_public_path__ + "static/media/svg-10.ff37c03d.svg";